import { render, staticRenderFns } from "./ShortcutsBlock.vue?vue&type=template&id=60034057"
import script from "./ShortcutsBlock.vue?vue&type=script&lang=js"
export * from "./ShortcutsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports